@if (!userTypes()) {
<div class="flex items-center justify-center mb-10">
  <div class="md:w-1/3 w-2/3">
    <activar-button-switch
      [buttons]="buttons"
      (clickButton)="setClientType($event)"
    />
  </div>
</div>
}

<activar-card>
  <form [formGroup]="userForm" (ngSubmit)="onSubmitHandler()" novalidate>
    <div class="flex flex-col gap-5 mb-5">
      @if (clientType() === 'person') {
      <div class="flex flex-col gap-1">
        <label for="firstName">Nombre</label>
        <input
          type="text"
          id="firstName"
          formControlName="firstName"
          class="input__base"
          placeholder="Juan"
          autocomplete="nope"
        />
        <app-input-error [control]="userForm.controls['firstName']" [submitted]="isSubmitted" />
      </div>
      <div class="flex flex-col gap-1">
        <label for="lastName">Apellido</label>
        <input
          type="text"
          id="lastName"
          formControlName="lastName"
          class="input__base"
          placeholder="gómez"
          autocomplete="nope"
        />
        <app-input-error [control]="userForm.controls['lastName']" [submitted]="isSubmitted" />
      </div>
      } @else {
      <div>
        <label for="businessName">Razón Social</label>
        <input
          class="input__base capitalize"
          formControlName="businessName"
          id="businessName"
          [ngClass]="{
							error:
								userForm.get('businessName')?.invalid &&
								userForm.get('businessName')?.touched &&
								isSubmitted,
						}"
        />

        @if (userForm.get('businessName')?.errors && isSubmitted) {
        <div class="error">
          <div>Por favor, ingrese un número válido.</div>
        </div>
        }
      </div>
      @if (quoterState().risk.tag === 'transportation_goods') {
      <div class="flex flex-col gap-1">
        <label for="identification">CUIT</label>
        <input
          type="text"
          id="identification"
          formControlName="identification"
          class="input__base"
          mask="00-00000000-0"
          cuitBlurNormalize
        />
        <app-input-error [control]="userForm.controls['identification']" [submitted]="isSubmitted" />
      </div>
      } }
      <div class="flex flex-col gap-1">
        <label for="email">{{ getEmailLabel() }}</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          class="input__base"
          placeholder="asegurado@gmail.com"
          autocomplete="nope"
        />
        <app-input-error [control]="userForm.controls['email']" [submitted]="isSubmitted" />
      </div>

      @if (hasRiskPostalCode(quoterState().risk.tag)) {
      <div class="flex flex-col gap-1">
        <label for="postalCode">Código postal</label>
        <input
          type="number"
          id="postalCode"
          formControlName="postalCode"
          class="input__base"
          autocomplete="nope"
          (change)="checkPostalCode()"
        />
        <app-input-error [control]="userForm.controls['postalCode']" [submitted]="isSubmitted" />
      </div>

      @if (zones() && zones().length > 1 && !selectedZone()) {
      <div>
        <div>
          Tu código postal fue encontrado en varias provincias, por favor elegí
          la correcta:
        </div>
        <div class="flex gap-5 items-center justify-star mt-2">
          @for (zone of zones(); track zone.id) {
          <activar-button
            color="primary"
            type="button"
            fill="out"
            [text]="zone.province.name"
            (click)="setZone(zone)"
          />
          }
        </div>
      </div>
      } }
    </div>
    <activar-button
      type="submit"
      color="primary"
      text="Continuar"
      [loading]="loading()"
      loadingText="Confirmando código postal..."
      expand="full"
      [disabled]="!userForm.valid || isPostalCodeValidated()"
    />
  </form>
</activar-card>
